webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(43)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(58),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(45)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(60),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Lists__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Lists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Lists__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SingleFile__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SingleFile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_SingleFile__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/archivo/:slug',
    name: 'single',
    component: __WEBPACK_IMPORTED_MODULE_3__components_SingleFile___default.a
  }, {
    path: '/:type?/:slug?',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Lists___default.a
  }]
}));

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(41)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(56),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(13);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TopicsAreas__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TopicsAreas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TopicsAreas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Sidebar__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Lists__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Lists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Lists__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'topics-areas': __WEBPACK_IMPORTED_MODULE_0__components_TopicsAreas___default.a,
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components_Sidebar___default.a,
    Lists: __WEBPACK_IMPORTED_MODULE_2__components_Lists___default.a
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_paginate__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fileRow__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fileRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fileRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loading__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Loading__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
/* global datos_abiertos */







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lists',
  components: {
    filerow: __WEBPACK_IMPORTED_MODULE_2__fileRow___default.a,
    paginate: __WEBPACK_IMPORTED_MODULE_1_vuejs_paginate___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_3__Loading___default.a
  },
  data: function data() {
    return {
      pageTitle: 'Más recientes',
      error: [],
      files: [],
      page: 1,
      numpages: 1,
      isLoading: false
    };
  },

  methods: {
    changeTitle: function changeTitle(route) {
      var title = '';
      switch (route.params.type) {
        case 'tematica':
          title = 'Temáticas';
          break;
        case 'tag':
          title = 'Palabras Clave';
          break;
        case 'area':
          title = 'Áreas';
          break;
        case 'search':
          title = 'Busqueda / ' + route.params.slug;
          break;
        default:
          title = 'Más recientes';
      }

      this.pageTitle = title;
    },
    loadData: function loadData(route, pageNum) {
      var _this = this;

      this.isLoading = true;
      var page = pageNum ? pageNum : 1;
      var apiUrl = datos_abiertos.api_url;
      var data = {
        'taxonomy': route.params.type,
        'term': route.params.slug,
        'page': page
      };

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + '/wp-json/datos-abiertos/v1/datos', data).then(function (response) {
        _this.isLoading = false;
        if (response.status === 200) {
          _this.files = response.data.posts;
          _this.numpages = response.data.numpages;
          _this.page = response.data.page;
        }
      }).catch(function (e) {
        _this.error = e;
        console.log(_this.error);
      });
    },
    doNavigation: function doNavigation(pageNum) {
      this.loadData(this.$route, pageNum);
    }
  },
  created: function created() {
    this.changeTitle(this.$route);
    this.loadData(this.$route);
  },

  watch: {
    $route: function $route(value) {
      this.changeTitle(value);
      this.loadData(value);
    }
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading'
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_scrollto__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_scrollto__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navitem',
  props: ['title', 'icon', 'categories', 'slug', 'childrens'],
  data: function data() {
    return {
      isActive: false
    };
  },

  methods: {
    goToDataView: function goToDataView() {
      __WEBPACK_IMPORTED_MODULE_0_vue_scrollto___default.a.scrollTo('#view-data', 500);
    },
    getClasses: function getClasses() {
      return 'fa ' + this.icon;
    },
    toggleActive: function toggleActive(event) {
      if (event.target.tagName === 'H5') {
        this.isActive = !this.isActive;
      }
    }
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavItem__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__NavItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Loading__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Loading__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global datos_abiertos  */





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebar',
  data: function data() {
    return {
      apiUrl: '',
      sections: [],
      errors: [],
      isLoading: true,
      searchValue: ''
    };
  },

  components: {
    NavItem: __WEBPACK_IMPORTED_MODULE_1__NavItem___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_2__Loading___default.a
  },
  methods: {
    processForm: function processForm() {
      this.$router.push({
        name: 'home',
        params: {
          type: 'search', slug: this.searchValue
        }
      });
      this.searchValue = '';
    }
  },
  created: function created() {
    var _this = this;

    this.apiUrl = datos_abiertos.api_url;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiUrl + '/wp-json/datos-abiertos/v1/sidebar').then(function (response) {
      _this.isLoading = false;
      if (response.status === 200) {
        _this.sections = response.data;
        //          console.log(this.sections);
      }
    }).catch(function (e) {
      _this.error = e;
      console.log(_this.error);
    });
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loading__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Loading__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* global datos_abiertos */
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SingleFile',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1__Loading___default.a
  },
  data: function data() {
    return {
      file: {},
      topic: '',
      area: '',
      area_description: '',
      isLoading: false
    };
  },
  created: function created() {
    var _this = this;

    this.isLoading = true;
    var slug = this.$route.params.slug;
    var apiUrl = datos_abiertos.api_url;
    var data = {
      slug: slug
    };
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + '/wp-json/datos-abiertos/v1/archivo', data).then(function (response) {
      _this.isLoading = false;
      if (response.status === 200) {
        _this.file = response.data;
        _this.topic = _this.file.topics[0].title;
        _this.area = _this.file.areas[0].title;
        _this.area_description = _this.file.areas[0].description;
      }
    }).catch(function (e) {
      _this.error = e;
      console.log(_this.error);
    });
  },

  methods: {
    canShowRecentFile: function canShowRecentFile() {
      if (this.file.current_files) {
        return this.file.current_files.length;
      }
      return false;
    },
    canShowHistoryFile: function canShowHistoryFile() {
      if (this.file.historical_files) {
        return this.file.historical_files.length;
      }
      return false;
    },
    canShowFileDescription: function canShowFileDescription() {
      if (this.file.description) {
        return this.file.description.length;
      }
      return false;
    },
    canShowDetailsLink: function canShowDetailsLink(externalLink) {
      if (externalLink) {
        return externalLink.length;
      }
      return false;
    }
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Loading__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Loading__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global $ */





/* global datos_abiertos */
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'topics-areas',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2__Loading___default.a
  },
  methods: {
    goToDataView: function goToDataView() {
      __WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default.a.scrollTo('#view-data', 500);
    }
  },
  data: function data() {
    return {
      topics: [],
      isLoading: true
    };
  },
  created: function created() {
    var _this = this;

    var apiUrl = datos_abiertos.api_url;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + '/wp-json/datos-abiertos/v1/tematicas').then(function (response) {
      _this.isLoading = false;
      if (response.status === 200) {
        //          console.log(response.data);
        _this.topics = response.data;
      }
    }).catch(function (e) {
      _this.error = e;
      console.log(_this.error);
    });
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_scrollto__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_scrollto__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'filerow',
  props: ['title', 'link', 'term', 'modified', 'area'],
  methods: {
    goToDataView: function goToDataView() {
      __WEBPACK_IMPORTED_MODULE_0_vue_scrollto___default.a.scrollTo('#view-data', 500);
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(44)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(59),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(42)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(57),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(47)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(62),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(46)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(61),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(55),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {}, [_c('router-link', {
    attrs: {
      "to": {
        name: 'single',
        params: {
          slug: _vm.link
        }
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToDataView($event)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.title))])])], 1), _vm._v(" "), _c('td', {}, [_c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.term))])]), _vm._v(" "), _c('td', {}, [(_vm.area) ? _c('p', [_vm._v(_vm._s(_vm.area))]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "app"
    }
  }, [_c('section', {
    staticClass: "topics-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('topics-areas')], 1)]), _vm._v(" "), _c('section', {
    staticClass: "data-holder",
    attrs: {
      "id": "view-data"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "sidebar col-md-3"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('sidebar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-data col-md-9 extended"
  }, [_c('div', {
    staticClass: "inner data"
  }, [_c('router-view')], 1)])])])])])
},staticRenderFns: []}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('h4', [_vm._v("Buscar datos")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.processForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-required": "true",
      "name": "search-input",
      "placeholder": "Palabra clave"
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.isLoading) ? _c('loading') : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "accordion fancy radius clean"
  }, _vm._l((_vm.sections), function(section) {
    return _c('nav-item', {
      key: section.title,
      attrs: {
        "slug": section.slug,
        "title": section.title,
        "icon": section.icon,
        "categories": section.topics
      }
    })
  })) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "id": "widget-subscribe-submit-button"
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  })])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center align-items-center loading"
  }, [_vm._v("\n      Cargando...\n    ")])])])
}]}

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ac-item",
    class: [_vm.isActive ? 'ac-active' : ''],
    on: {
      "click": _vm.toggleActive
    }
  }, [_c('h5', {
    staticClass: "ac-title"
  }, [_c('i', {
    class: _vm.getClasses()
  }), _vm._v(" " + _vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "ac-content",
    class: [_vm.isActive ? 'showed' : 'hidden']
  }, [_c('div', {
    staticClass: "list-group"
  }, _vm._l((_vm.categories), function(category) {
    return _c('div', {
      key: category.id,
      staticClass: "list-group-item"
    }, [_c('router-link', {
      staticClass: "parent-link",
      attrs: {
        "to": {
          name: 'home',
          params: {
            type: _vm.slug,
            slug: category.slug
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.goToDataView($event)
        }
      }
    }, [_vm._v("\n          " + _vm._s(category.name) + "\n          "), _c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(category.count))])]), _vm._v(" "), (category.childrens) ? _c('div', {
      staticClass: "childrens-area"
    }, _vm._l((category.childrens), function(child) {
      return _c('router-link', {
        key: child.id,
        staticClass: "children-link",
        attrs: {
          "to": {
            name: 'home',
            params: {
              type: _vm.slug,
              slug: child.slug
            }
          }
        },
        nativeOn: {
          "click": function($event) {
            _vm.goToDataView($event)
          }
        }
      }, [_vm._v("\n            " + _vm._s(child.name) + "\n            "), _c('span', {
        staticClass: "badge"
      }, [_vm._v(_vm._s(child.count))])])
    })) : _vm._e()], 1)
  }))])])
},staticRenderFns: []}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "data-lists"
    }
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "breadcrumbs"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Datos Abiertos")]), _vm._v("\n      / " + _vm._s(_vm.pageTitle) + "\n    ")], 1), _vm._v(" "), (_vm.files.length == 0) ? _c('div', {
    staticClass: "no-results"
  }, [_vm._v("\n      Lo sentimos no encontramos ningún resultado con este criterio.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.files.length > 0) ? _c('div', {
    staticClass: "table table-condensed table-striped table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.files), function(file) {
    return _c('filerow', {
      key: file.permalink,
      attrs: {
        "title": file.title,
        "link": file.permalink,
        "modified": file.modified,
        "term": file.topics[0].title,
        "area": file.areas[0].title
      }
    })
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pagination-holder"
    }
  }, [(_vm.numpages > 1) ? _c('paginate', {
    attrs: {
      "page-count": _vm.numpages,
      "prev-text": 'Anterior',
      "next-text": 'Siguente',
      "container-class": 'pagination justify-content-center',
      "page-link-class": 'page-link',
      "prev-link-class": 'page-link',
      "next-link-class": 'page-link',
      "page-class": 'page-item',
      "prev-class": 'page-item',
      "next-class": 'page-item',
      "initial-page": _vm.page,
      "click-handler": _vm.doNavigation
    }
  }) : _vm._e()], 1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Descripción")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Tema")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Área")])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topics-areas"
    }
  }, [_c('div', {
    staticClass: "info"
  }, [_vm._m(0), _vm._v(" "), (_vm.isLoading) ? _c('loading') : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('ul', {
    staticClass: "grid grid-5-columns"
  }, _vm._l((_vm.topics), function(topic) {
    return _c('li', {
      key: topic.id
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'home',
          params: {
            type: 'tematica',
            slug: topic.slug
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.goToDataView($event)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": topic.image
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "img-caption"
    }, [_vm._v(_vm._s(topic.name))])])], 1)
  })) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('h3', [_vm._v("Temas")])])])
}]}

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dato-abierto"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "data"
  }, [_c('div', {
    staticClass: "breadcrumbs"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Datos Abiertos")]), _vm._v("\n      / " + _vm._s(_vm.topic) + "\n    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h3', [_vm._v(_vm._s(_vm.file.title))]), _vm._v(" "), _c('p', {
    staticClass: "area-topic"
  }, [_c('strong', [_vm._v("Tema:")]), _vm._v(" " + _vm._s(_vm.topic))]), _vm._v(" "), (_vm.file.tags) ? _c('p', [_c('strong', [_vm._v("Palabras clave:")]), _vm._v(" " + _vm._s(_vm.file.tags))]) : _vm._e(), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Descripción")]), _c('br'), _vm._v("\n        " + _vm._s(_vm.file.description) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-6",
    staticStyle: {
      "padding": "0 !important"
    }
  }, [(_vm.area) ? _c('p', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Área:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.area))]), _vm._v(" "), (_vm.area_description) ? _c('span', [_vm._v(" - " + _vm._s(_vm.area_description))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.file.last_update) ? _c('p', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Última actualización:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.file.last_update))])]) : _vm._e(), _vm._v(" "), (_vm.file.responsable) ? _c('p', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Responsable de los datos:")]), _vm._v(" " + _vm._s(_vm.file.responsable) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.file.email) ? _c('p', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Correo electrónico:")]), _vm._v(" " + _vm._s(_vm.file.email) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-6",
    staticStyle: {
      "padding": "0 !important"
    }
  }, [(_vm.file.frequency) ? _c('p', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Frecuencia de la actualización:")]), _vm._v(" " + _vm._s(_vm.file.frequency) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.file.position) ? _c('p', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Cargo:")]), _vm._v(" " + _vm._s(_vm.file.position) + "\n            ")]) : _vm._e()])])])]), _vm._v(" "), (_vm.canShowRecentFile()) ? _c('div', {
    staticClass: "files"
  }, [_c('h4', [_vm._v("Datos y Recursos")]), _vm._v(" "), _c('div', {
    staticClass: "table table-condensed table-striped table-responsive"
  }, [_c('table', {
    staticClass: "table open-files"
  }, [_c('tbody', _vm._l((_vm.file.current_files), function(da_file) {
    return _c('tr', {
      staticClass: "file-details"
    }, [_vm._m(0, true), _vm._v(" "), _c('td', {
      staticClass: "title"
    }, [(_vm.canShowFileDescription()) ? _c('span', [_vm._v(_vm._s(da_file.description))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "download"
    }, [(_vm.canShowDetailsLink(da_file.external_link)) ? _c('a', {
      staticClass: "button pink-dark rounded icon-left small",
      attrs: {
        "href": da_file.external_link,
        "target": "_blank"
      }
    }, [_vm._m(1, true)]) : _vm._e(), _vm._v(" "), (_vm.canShowDetailsLink(da_file.external_link)) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.canShowDetailsLink(da_file.external_link)) ? _c('br') : _vm._e(), _vm._v(" "), (da_file.url) ? _c('a', {
      staticClass: "button pink-dark rounded icon-left small",
      attrs: {
        "href": da_file.url,
        "target": "_blank"
      }
    }, [_vm._m(2, true)]) : _vm._e()])])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.canShowHistoryFile()) ? _c('div', {
    staticClass: "files"
  }, [_c('h4', [_vm._v("Archivos Históricos")]), _vm._v(" "), _c('div', {
    staticClass: "table table-condensed table-striped table-responsive"
  }, [_c('table', {
    staticClass: "table open-files"
  }, [_c('tbody', _vm._l((_vm.file.historical_files), function(da_file) {
    return _c('tr', {
      staticClass: "file-details"
    }, [_vm._m(3, true), _vm._v(" "), _c('td', {
      staticClass: "title"
    }, [(_vm.canShowFileDescription()) ? _c('span', [_c('br'), _vm._v(_vm._s(da_file.description))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "download"
    }, [(_vm.canShowDetailsLink(da_file.external_link)) ? _c('a', {
      staticClass: "button pink-dark rounded icon-left small",
      attrs: {
        "href": da_file.external_link,
        "target": "_blank"
      }
    }, [_vm._m(4, true)]) : _vm._e(), _vm._v(" "), (_vm.canShowDetailsLink(da_file.external_link)) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.canShowDetailsLink(da_file.external_link)) ? _c('br') : _vm._e(), _vm._v(" "), (da_file.url) ? _c('a', {
      staticClass: "button pink-dark rounded icon-left small",
      attrs: {
        "href": da_file.url,
        "target": "_blank"
      }
    }, [_vm._m(5, true)]) : _vm._e()])])
  }))])])]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "icon"
  }, [_c('span', {}, [_c('i', {
    staticClass: "fa fa-file fa-4x"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-external-link"
  }), _vm._v("Ver Datos")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("Descarga")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "icon"
  }, [_c('span', {}, [_c('i', {
    staticClass: "fa fa-file fa-4x"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-chart"
  }), _vm._v("Vista Previa")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("Descarga")])
}]}

/***/ })
],[32]);


// WEBPACK FOOTER //
// static/js/app.js